import useActionReducer from '@admin/hooks/use_action_reducer'
import MBlocksDesigner from './mblocks_designer'
import * as actions from './actions'
import PropTypes from 'prop-types'
import reducer from './reducer'
import React from 'react'

const MBlocksDesignerContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'mblocks_designer',
    actions,
    props,
    reducer
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <MBlocksDesigner { ...mergedProps } />

}

MBlocksDesignerContainer.propTypes = {}

export default MBlocksDesignerContainer